"use client";
import { CallToActionSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";

const CallToAction: FC<CallToActionSectionProps> = () => {
  return (
    <h3
      style={{
        backgroundColor: "black",
        color: "white",
        textAlign: "center",
        padding: 50,
      }}
    >
      CallToAction
    </h3>
  );
};

export default CallToAction;
